






























import {Component, Vue} from 'vue-property-decorator';
import PortalMoneyInput from '@/components/common/PortalMoneyInput.vue';
import {TaxObligationLedgerRecordDTO} from '@/dto/tax/TaxObligationDTO';
import {getTaxObligationLiabilityTypeLabel} from '@/constants/TaxObligationLiabilityType';
import TaxObligationService from '@/services/TaxObligationService';
import Workspaces from '@/state/Workspaces';
import Application from '@/state/Application';
import {processError} from '@/utils/ComponentUtils';
import {canEditAssessment, isValidAssessmentAmount, linkedPaymentTotal} from '@/utils/TaxAssessmentUtils';

@Component({components: {PortalMoneyInput}})
export default class EditTaxAssessmentModal extends Vue {
  taxObligationId: number | null = null;
  record: TaxObligationLedgerRecordDTO | null = null;
  ledger: TaxObligationLedgerRecordDTO[] = [];
  amountCents: number | null = null;
  saving = false;

  beforeOpen(event: {params: {taxObligationId: number; record: TaxObligationLedgerRecordDTO; ledger?: TaxObligationLedgerRecordDTO[]}}): void {
    this.taxObligationId = event.params.taxObligationId;
    this.record = {...event.params.record};
    this.ledger = event.params.ledger || [];
    this.amountCents = this.record.amountCents;
    this.saving = false;
    this.$validator.reset();
  }

  beforeClose(event: {cancel: () => void}): void {
    if (this.saving) event.cancel();
  }

  closeModal(): void {
    if (!this.saving) this.$modal.hide('edit-tax-assessment-modal');
  }

  get assessmentLabel(): string {
    if (!this.record) return '';
    return this.record.liabilityType ? getTaxObligationLiabilityTypeLabel(this.record.liabilityType)
      : this.$stringUtils.enumToFormattedSentence(this.record.transactionType);
  }

  get isValid(): boolean {
    return Workspaces.isUserSublimeEmployee && this.taxObligationId != null
      && this.record != null && canEditAssessment(this.record) && isValidAssessmentAmount(this.amountCents);
  }

  get warningMessage(): string | null {
    if (!this.record || !isValidAssessmentAmount(this.amountCents) || this.amountCents >= this.record.amountCents) return null;
    const total = linkedPaymentTotal(this.ledger, this.record);
    if (this.amountCents >= total) return null;
    const currency = (cents: number) => new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(cents / 100);
    return this.$t('tax_calendar.warnings.assessment_below_payments', {
      total: currency(total), amount: currency(this.amountCents), excess: currency(total - this.amountCents),
    }) as string;
  }

  async submit(): Promise<void> {
    if (this.saving) return;
    const valid = await this.$validator.validateAll();
    if (!valid || !this.isValid || this.saving) return;
    this.saving = true;
    Application.startLoading();
    try {
      await TaxObligationService.updateLedgerRecordAmount(this.taxObligationId!, this.record!.id, {amountCents: this.amountCents!});
    } catch (error) {
      processError(error, this);
      return;
    } finally {
      this.saving = false;
      Application.stopLoading();
    }
    this.closeModal();
    this.$emit('updated');
  }
}
